import angular from 'angular';

import progressButtonUrl from './progressButton.html';

export default function progressButton() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      inprogress: '=',
    },
    controllerAs: 'ctrl',
    templateUrl: progressButtonUrl,
    link($scope, $element, $attrs) {
      const { ctrl } = $scope;
      if (!$attrs.type) {
        $element[0].type = 'button';
      }

      ctrl.init();
      ctrl.initSmartProgress();
    },
    controller: class ProgressButtonCtrl {
      constructor($scope, $element, $attrs, $q, $http, $timeout, $parse, $compile) {
        'ngInject';

        Object.assign(this, { $scope, $element, $attrs, $q, $http, $timeout, $parse, $compile });

        this._status = 0;
        this._incTimeout = null;
        this._completeTimeout = null;
        this._fn = null;
      }

      init() {
        this._ignoreState = Boolean(this.$attrs.pbIgnoreState);
        this.width = 0;

        if (this.$attrs.pbClick) {
          this.$element.on('click', (event) => {
            this._fn = this.$parse(this.$attrs.pbClick);
            const promise = this._fn(this.$scope.$parent, { $event: event });
            if (promise === false) {
              this._fail();
            }

            if (promise === true) {
              this._success();
            }

            if (promise && promise.then) {
              this._disable();
              promise.then(this._success.bind(this), this._fail.bind(this));
            }
          });
        } else if (this.$element[0].form && this.$element[0].form.attributes['pb-submit']) {
          this.$element[0].form.onsubmit = (event) => {
            this._fn = this.$parse(this.$element[0].form.attributes['pb-submit'].nodeValue);
            const promise = this._fn(this.$scope.$parent, { $event: event });
            if (promise === false) {
              this._fail();
            }

            if (promise === true) {
              this._success();
            }

            if (promise && promise.then) {
              this._disable();
              promise.then(this._success.bind(this), this._fail.bind(this));
            }
          };
        }

        this.$scope.$watch('inprogress', (newValue, oldValue) => {
          if (newValue === true) {
            this._disable();
          }

          if (newValue === 'error' && oldValue === true) {
            this._fail();
          }

          if (newValue === false && oldValue === true) {
            this._success();
          }
        });
      }

      initSmartProgress() {
        this.cloneLeftHolder = angular.element(
          this.$element[0].querySelector('.progress-button-content-clone-left')
        );
        this.cloneLeft = angular.element(this.cloneLeftHolder[0].querySelector('[ng-transclude]'));
        this.cloneRightHolder = angular.element(
          this.$element[0].querySelector('.progress-button-content-clone-right')
        );
        this.cloneRight = angular.element(
          this.cloneRightHolder[0].querySelector('[ng-transclude]')
        );

        const elementPadding = getComputedStyle(this.$element[0]).padding;
        this.cloneLeft.css('padding', elementPadding);
        this.cloneRight.css('padding', elementPadding);

        this.updateClonesLayout();
      }

      getCssTransform(cssValue) {
        return ['-webkit-transform', 'transform'].reduce(
          (acc, prop) => ((acc[prop] = cssValue), acc),
          {}
        );
      }

      updateClonesLayout() {
        this.cloneLeftHolder.css(this.getCssTransform(`translateX(-${100 - this.width}%)`));
        this.cloneLeft.css(this.getCssTransform(`translateX(${100 - this.width}%)`));
        this.cloneRightHolder.css(this.getCssTransform(`translateX(${this.width}%)`));
        this.cloneRight.css(this.getCssTransform(`translateX(-${this.width}%)`));
      }

      _inc() {
        if (this._status >= 1) {
          return;
        }

        let rnd = 0;

        if (this._status >= 0 && this._status < 0.25) {
          // Start out between 10 - 15% increments
          rnd = (Math.random() * 10 + 5) / 100;
        } else if (this._status >= 0.25 && this._status < 0.65) {
          // increment between 0 - 10%
          rnd = (Math.random() * 10) / 100;
        } else if (this._status >= 0.65 && this._status < 0.9) {
          // increment between 0 - 5%
          rnd = (Math.random() * 5) / 100;
        } else if (this._status >= 0.9 && this._status < 0.99) {
          // finally, increment it .5 %
          rnd = 0.005;
        } else {
          // after 99%, don't increment:
          rnd = 0;
        }

        const pct = this._status + rnd;
        this._set(pct);
      }

      async _set(n) {
        this.width = n * 100;
        this._status = n;
        this.updateClonesLayout();

        this.$timeout.cancel(this._incTimeout);
        this._incTimeout = this.$timeout(250);
        try {
          await this._incTimeout;
          this._inc();
        } catch {
          //
        }
      }

      async _complete() {
        this.disabled = false;
        this.$attrs.$set('disabled', false);
        this.$element.removeClass('state-loading');
        this._set(1);
        this.width = 0;

        if (!this._ignoreState) {
          this._completeTimeout = this.$timeout(1500);
          try {
            await this._completeTimeout;
            this.$element.removeClass('state-success');
            this.$element.removeClass('state-error');
            if ('ngDisabled' in this.$attrs) {
              const disabledAttrGetter = this.$parse(this.$attrs.ngDisabled);

              this.$attrs.$set('disabled', disabledAttrGetter(this.$scope.$parent));
            }
          } catch {
            //
          }
        }
      }

      _success(data) {
        this._complete();
        if (!this._ignoreState) {
          this.$element.addClass('state-success');
        }
        return data;
      }

      _fail(error) {
        console.error(error);
        this._complete();
        if (!this._ignoreState) {
          this.$element.addClass('state-error');
        }
        return error;
      }

      _disable() {
        this.disabled = true;
        this.$timeout.cancel(this._completeTimeout);
        this.$attrs.$set('disabled', true);
        this.$element.addClass('state-loading');
        this._set(0.02);
      }
    },
  };
}
